
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './SchoolCodingCourse.css';

const levels = [
    {
        number: '01',
        title: 'Junior Coding',
        classes: 'Class 6–8',
        duration: '500 / Month',
        icon: '🎮',
        description:
            'Start your coding journey with fun activities, games and beginner-friendly programming.',
        topics: [
            'Computer Fundamentals and Logical Thinking',
            'Introduction to Scratch Programming',
            'Python Programming Basics',
            'Variables, Conditions, Loops and Functions',
            'Creating Games, Animations and Quizzes',
            'Introduction to Artificial Intelligence',
            'AI Tools and Responsible AI Usage',
        ],
        projects: [
            'Interactive Quiz Application',
            'Simple Coding Game',
        ],
    },
    {
        number: '02',
        title: 'Python & AI Fundamentals',
        classes: 'Class 9–10',
        duration: '700 / Month',
        icon: '🐍',
        description:
            'Learn Python programming, problem-solving, data analysis and the fundamentals of AI and ML.',
        topics: [
            'Python Programming Fundamentals',
            'Data Types, Functions and Data Structures',
            'Problem-Solving and Coding Challenges',
            'Introduction to Artificial Intelligence',
            'Machine Learning Fundamentals',
            'Data Analysis Using Python',
            'NumPy, Pandas and Data Visualization Basics',
            'Introduction to ML Datasets and Models',
        ],
        projects: [
            'Python-Based Application',
            'Data Analysis Project',
        ],
    },
    {
        number: '03',
        title: 'Advanced Coding, AI & ML',
        classes: 'Class 11–12',
        duration: '900 / Month',
        icon: '🤖',
        description:
            'Explore advanced Python, machine learning models and practical AI application development.',
        topics: [
            'Advanced Python and Object-Oriented Programming',
            'Data Analysis and Visualization',
            'Machine Learning Fundamentals and Algorithms',
            'Supervised and Unsupervised Learning',
            'Training and Testing Basic ML Models',
            'Introduction to Neural Networks and Deep Learning',
            'Generative AI, LLMs and Prompt Engineering',
            'Building Applications Using AI APIs',
        ],
        projects: [
            'AI Chatbot',
            'Machine Learning Prediction Model',
            'Image Classification Project',
        ],
    },
];

const SchoolCodingCourse = () => {
    const navigate = useNavigate();

    return (
        <div className="school-course-page">
            <nav className="school-course-nav">
                <button
                    type="button"
                    className="school-back-btn"
                    onClick={() => navigate(-1)}
                >
                    ← Back
                </button>

                <a
                    href="https://aptechsolution.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="school-website-btn"
                >
                    Visit Website ↗
                </a>
            </nav>
            <section className="school-course-hero">
                <span className="school-course-tag">
                    NextZen IT Academy
                </span>

                <h1>
                    AI & Coding
                    <span> for School Students</span>
                </h1>

                <p>
                    Empower your child's future with Coding,
                    Python, Artificial Intelligence and Machine
                    Learning through hands-on projects.
                </p>

                <div className="school-course-classes">
                    <span>Class 6–8</span>
                    <span>Class 9–10</span>
                    <span>Class 11–12</span>
                </div>

                <button
                    type="button"
                    onClick={() => {
                        const phone = '919426944526';
                        const message =
                            'Hello A.P Tech Solutions, I want to enquire about the AI & Coding Academy for School Students. Please share the syllabus, fees, duration and batch details.';

                        window.open(
                            `https://wa.me/${phone}?text=${encodeURIComponent(message)}`,
                            '_blank'
                        );
                    }}
                >
                    Enquire on WhatsApp →
                </button>
            </section>

            <section className="school-course-intro">
                <h2>Learn Coding Step by Step</h2>
                <p>
                    A structured learning journey designed for
                    school students, starting with basic coding
                    and progressing towards Python, AI and
                    Machine Learning projects.
                </p>
            </section>

            <section className="school-course-levels">
                {levels.map((level) => (
                    <article
                        className="school-level-card"
                        key={level.number}
                    >
                        <div className="school-level-top">
                            <div className="school-level-icon">
                                {level.icon}
                            </div>

                            <span className="school-level-number">
                                LEVEL {level.number}
                            </span>
                        </div>

                        <h2>{level.title}</h2>

                        <div className="school-level-meta">
                            <span>🎓 {level.classes}</span>
                            <span>🗓️ {level.duration}</span>
                        </div>

                        <p className="school-level-description">
                            {level.description}
                        </p>

                        <h3>What You Will Learn</h3>

                        <ul className="school-topic-list">
                            {level.topics.map((topic) => (
                                <li key={topic}>
                                    <span>✓</span>
                                    {topic}
                                </li>
                            ))}
                        </ul>

                        <h3>Practical Projects</h3>

                        <ul className="school-project-list">
                            {level.projects.map((project) => (
                                <li key={project}>
                                    💡 {project}
                                </li>
                            ))}
                        </ul>

                        <button
                            type="button"
                            className="school-level-button"
                            onClick={() => {
                                const phone = '919426944526';
                                const message =
                                    `Hello A.P Tech Solutions, I want to enquire about ${level.title} for ${level.classes}. Please share the fees and batch details.`;

                                window.open(
                                    `https://wa.me/${phone}?text=${encodeURIComponent(message)}`,
                                    '_blank'
                                );
                            }}
                        >
                            Enquire About This Level →
                        </button>
                    </article>
                ))}
            </section>

            <section className="school-course-bottom">
                <h2>Give Your Child a Head Start in Technology</h2>
                <p>
                    Help your child develop logical thinking,
                    creativity and future-ready digital skills.
                </p>

                {/* <button
                    type="button"
                    onClick={() => navigate('/contact')}
                >
                    Contact Us
                </button> */}
            </section>
        </div>
    );
};

export default SchoolCodingCourse;
